class ScrollTo{

	constructor() {
		gsap.registerPlugin(ScrollTrigger);
		this.init();
	}

	init(){
		this.initScrollClick();
		this.initParallaxe();
	}

	initScrollClick(){
		//console.debug('👺 ScrollTo: initScrollClick');
		this.elem = document.querySelectorAll('.next')
		this.elem.forEach(el =>{
			el.addEventListener('click',()=>{

				let offset = 0;
				let header = document.querySelector('.head');
				if(header){
					offset = header.getBoundingClientRect().height;
				} else {
					offset = window.innerHeight;
				}

				window.scrollTo({top :offset, behavior: 'smooth'})
			})

		})
	}


	initParallaxe(){
		//console.debug('👺 ScrollTo: initParallaxe');

		// parallaxe des header
		// this.pageHeader = document.querySelector('.head');
		// if(this.pageHeader){
		// 	const tl = gsap.timeline({
		// 		scrollTrigger: {
		// 			trigger: this.pageHeader,
		// 			start: "top top",
		// 			scrub: true,
		// 			end: "+=500"
		// 		}
		// 	});
		// 	tl.to(this.pageHeader.querySelector('.head__main'), {y: 200, ease: "none"}, 0)
		// }

		this.textImage = document.querySelector('.textImage');
		if(this.textImage){
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: this.textImage,
					start: "top 80%",
					scrub: true,
					//markers: true
				}
			});
			tl.to(this.textImage.querySelector('.textImage__image'), {y: 200, ease: "none"}, 0)
		}

	}

	reset(){
		//console.debug('👺 ScrollTo: reset');
		let triggers = ScrollTrigger.getAll();
		triggers.forEach( trigger => {
			trigger.kill();
		});
	}

}

module.exports = ScrollTo;
